module.exports = __webpack_public_path__ + "media/no5.61ab4095.mp3";